import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { TopInstitutionsEffects } from './top-institutions.effects';
import { topInstitutionsFeature } from './top-institutions.reducer';

export const topInstitutionsStore = [
  provideState(topInstitutionsFeature),
  provideEffects(TopInstitutionsEffects),
];
